import React from 'react'
import { Link, Element } from 'react-scroll';
import AppIcon from '../../assests/app-store-icon.png'
import GoogleIcon from '../../assests/google-play-icon.png'
import BoxImg from '../../assests/img-box.png'
import BoxOne from '../../assests/img-box-one.png'
import BoxTwo from '../../assests/img-box-two.png'
import BoxThird from '../../assests/img-box-three.png'
import LogoIcon from '../../assests/zelo-logo-icon.png'
import "./MobileWeb.css"

function MobileWeb() {
  return (
    
    <div className="fast-capital-section">
     <div className="container">
        <div className="logo-box my-4">
            <a href="https://zelofinance.ai/">
                <img src={LogoIcon} style={{ width: 98 }} />
            </a>
        </div>
         <div className="heading-text text-center">
             <h2 className="px-4 mx-2">Fast Capital, Incredible Growth</h2>
             <p>Get fast, flexible financing for your business. Download the Zelo app to access your credit line and manage your funding on the go.</p>
         </div>
         <div className="download-apps-sec d-flex justify-content-center my-4">
             <p className="px-1 m-0"><Link href="#" smooth={true} duration={500}><img src={AppIcon} alt="Mobile App" className="img-fluid d-block" /></Link></p>
             <p className="px-1 m-0"><Link href="#" smooth={true} duration={500}><img src={GoogleIcon} alt="Mobile App" className="img-fluid d-block" /></Link></p>
         </div>
         <div className="fast-cap-box d-flex justify-content-center flex-wrap">
             <div className="box"><img src={BoxImg} alt="Box Image" className="w-100" /></div>
             <div className="box"><img src={BoxOne} alt="Box Image" className="w-100" /></div>
             <div className="box"><img src={BoxTwo} alt="Box Image" className="w-100" /></div>
             <div className="box"><img src={BoxThird} alt="Box Image" className="w-100" /></div>
         </div>
     </div>
    </div>
  )
}

export default MobileWeb
